import React, { Component } from "react";
import swal from 'sweetalert';

import { download } from "react-icons-kit/fa/download";

import Button from "../../components/Button";
import LabelForm from "../../components/LabelForm";
import InputForm from "../../components/InputForm";
import SelectForm from "../../components/SelectForm";
import AutocompleteForm from "../../components/AutocompleteForm";
import Modal from "../../components/Modal";
import IconButton from "../../components/IconButton";

import { convokePlacesOption, donorBasicInfo, getDateHour, lookups, lookupsOrderBy, 
    medicalStaffOption, samplesByOfferingCells, samplesDetails, samplesGetNextNumber, samplesOfferingCellsSave, 
    samplesOfferingCellsUpdate, 
    sampleTypes 
} from "../../libs/services";
import { getFormatHour, isValidForm, transformOptionsById, transformOptionsByKey } from "../../libs/functions";
import moment from "moment";
import Toolbar from "./toolbar/Register";

class RegisterSample extends Component{
    constructor(props){
        super(props);

        this.newRegister = this.newRegister.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getNextNumber = this.getNextNumber.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.openModal = this.openModal.bind(this);
        this.onChecked = this.onChecked.bind(this);
        this.getSampleDetails = this.getSampleDetails.bind(this);
        this.onClear = this.onClear.bind(this);

        this.state = {
            option:'save',
            name:"",
            group_rh:"",
            sex:"",
            donor_number:"",
            showForm:false,
            date:"",
            time:"",
            sample_number:"",
            sample_types_id:"",
            tube_type:"",
            arm:"",
            vein:"",
            volume:"",
            temperature:"",
            medical_staff_id:"",
            convoke_place_id:"",
            sampleTypes:[],
            tubeTypes:[],
            arms:[],
            veins:[],
            medicals:[],
            convoke_places:[],
            index_medical:-1,
            load_medical:false,
            maternal_flag:false,
            mothers_name:"",
            offering_cell_id:"",
            samples:[],
            sample_id:"",
            sample_type:'DONOR'
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    async openModal(donor_id, offering_cell_id){
        if(this.props.screen === 'celulas'){
            var response = await donorBasicInfo(donor_id);
            if(response){
                this.setState({
                    name:response.lastnames+' '+response.name,
                    group_rh:response.group_rh,     
                    sex:response.sex,
                    donor_number:response.donor_number               
                });
            }

            response = await samplesByOfferingCells(offering_cell_id);
            if(response){
                var options = response.map((res)=>{
                    var obj = {
                        value:res.id,
                        text:res.number+' ('+res.type+')'
                    }

                    return obj;
                });

                this.setState({samples:options});
            }
            this.setState({offering_cell_id:offering_cell_id});

            this.modal.handleShow();
        }
    }

    async newRegister(){
        var options = [];
        var response = await getDateHour();
        if(response){
            var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-');
			var hours = getFormatHour(aux[1]);

            this.setState({date:date, time:hours});
        }

        response = await sampleTypes();
        if(response){
            options = transformOptionsById(response);

            this.setState({sampleTypes: options});
        }

        response = await lookupsOrderBy('TUBE_TYPE');
        if(response){
            options = transformOptionsByKey(response);
            this.setState({tubeTypes: options});
        }

        response = await lookupsOrderBy('arm_type');
        if(response){
            options = transformOptionsByKey(response);
            this.setState({arms: options});
        }

        response = await lookups('VEIN_TYPE', 'false');
        if(response){
            options = transformOptionsByKey(response);
            this.setState({veins: options});
        }

        response = await medicalStaffOption('mainInfo');
        if(response){
            response.forEach((res)=>{
                res.values = res.medical_staff.lastname1+' '+(res.medical_staff.lastname2 !== null ? res.medical_staff.lastname2 : "")+' '+res.medical_staff.names
            });

            this.setState({medicals:response});
        }

        response = await convokePlacesOption('for_cells', sessionStorage.getItem("health_facilities_id"));
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value:res.convoke_places.id,
                    text:res.convoke_places.name
                };

                return obj;
            });

            this.setState({convoke_places:options});
        }

        this.setState({showForm:true});
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'sample_id'){
            this.getSampleDetails(e.target.value);
        }
    }

    async getSampleDetails(id){
        var response = await samplesDetails(id);
        if(response){
            await this.newRegister();

            await this.setState({
                option:'update',
                date:moment(response.timestamp).format('YYYY-MM-DD'),
                time:moment(response.timestamp).format('HH:mm'),
                sample_types_id:response.sample_types_id,
                sample_number:response.number,
                tube_type:response.tube_type,
                arm:response.arm,
                vein:response.vein,
                volume:response.volume,
                temperature:response.temperature,
                convoke_place_id:response.convoke_places_id,
                maternal_flag:response.maternal_flag,
                mothers_name:response.mothers_name
            });

            var medicals = [{medical_staff:{id:response.medical_staff_id}}];
            await this.onAutocompleteChange(medicals);
        }
    }

    onChecked(e){
        this.setState({[e.target.name]: e.target.checked});
    }

    async getNextNumber(){
        var response = await samplesGetNextNumber(sessionStorage.getItem('health_facilities_id'), this.state.sample_type);
        if(response){
            this.setState({sample_number:response});
        }
    }

    onAutocompleteChange(values){
        if(values.length > 0){
            var value = values[0];
            var index = this.state.medicals.findIndex(obj => obj.medical_staff.id === value.medical_staff.id);
            this.setState({
                index_medical:index,
                medical_staff_id:value.medical_staff.id
            });
        }
    }

    async onSave(){
        var error = '';
        if(!isValidForm('div.modal-sample-form')){
            error = 'Campos incompletos';
        };

        if(error === ''){
            var obj = {
                number:this.state.sample_number,
                convoke_places_id:this.state.convoke_place_id,
                timestamp:this.state.date+'T'+moment(this.state.time, 'HH:mm').format('HH:mm:ss.sss'),
                sample_types_id:this.state.sample_types_id,
                maternal_flag:this.state.maternal_flag,
                mothers_name:this.state.mothers_name,
                medical_staff_id:this.state.medical_staff_id,
                tube_type:this.state.tube_type,
                arm:this.state.arm,
                vein:this.state.vein,
                volume:this.state.volume,
                temperature:this.state.temperature,
                offering_cell_id:this.state.offering_cell_id
            }
            
            var response;
            if(this.state.option === 'save'){
                response = await samplesOfferingCellsSave(obj, this.props.waiting);
            }else{
                obj.id = this.state.sample_id;

                response = await samplesOfferingCellsUpdate(obj.id, obj, this.props.waiting);
            }

            if(response){
                this.onClear();
                this.modal.handleClose();
                this.props.updateList();
            }
        }else{
            swal('Error', error, 'error');
        }
    }

    onClear(){
        this.setState({
            option:'save',
            name:"",
            group_rh:"",
            sex:"",
            donor_number:"",
            showForm:false,
            date:"",
            time:"",
            sample_number:"",
            sample_types_id:"",
            tube_type:"",
            arm:"",
            vein:"",
            volume:"",
            temperature:"",
            medical_staff_id:"",
            convoke_place_id:"",
            sampleTypes:[],
            tubeTypes:[],
            arms:[],
            veins:[],
            medicals:[],
            convoke_places:[],
            index_medical:-1,
            load_medical:false,
            maternal_flag:false,
            mothers_name:"",
            offering_cell_id:"",
            samples:[],
            sample_id:"",
            sample_type:'DONOR'
        });
    }

    render(){
        const {t} = this.props;
        return(
            <Modal 
                title="Registro de muestra"                 
                actionBtn={true}
                label={t('content.generics.buttons.save')}
                action={this.onSave}
                clear={this.onClear}
                onRef={ref => this.modal = ref}
            >
                <div className="row">
                    <div className="col-xs-12 form-group no-padding">
                        <div className="col-xs 12 col-sm-4">
                            <div className="col-xs-12">
                                <LabelForm text="Paciente/Donador" />
                            </div>
                            <div className="col-xs-12">
                                {this.state.name}
                            </div>
                        </div>
                        <div className="ol-xs 12 col-sm-4">
                            <div className="col-xs-12">
                                <LabelForm text="Grupo & RH" />
                            </div>
                            <div className="col-xs-12">
                                {this.state.group_rh} 
                            </div>
                        </div>
                        <div className="ol-xs 12 col-sm-4">
                            <div className="col-xs-12">
                                <LabelForm text="Sexo" />
                            </div>
                            <div className="col-xs-12">
                               {this.state.sex}
                            </div>
                        </div>
                        <div className="ol-xs 12 col-sm-4">
                            <div className="col-xs-12">
                                <LabelForm text="No. Donador" />
                            </div>
                            <div className="col-xs-12">
                                {this.state.donor_number}
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-xs-12 form-group">
                        {this.state.samples.length > 0 &&
                            <div className="col-xs-12 col-sm-4">
                                <LabelForm text="Muestras" />
                                <SelectForm 
                                    id="sample_id"
                                    value={this.state.sample_id}
                                    options={this.state.samples}
                                    handleChange={this.handleChange}
                                />
                            </div>
                        }
                        
                        <div className="col-xs-12 col-sm-1">
                            <Button 
                                class="btn-info btn-sm"
                                title="Nuevo registro"
                                action={this.newRegister}
                                text="Nuevo"
                                styles={{marginTop:18}}
                            />
                        </div>                        
                    </div>
                    {this.state.showForm &&
                        <div className="col-xs-12 no-padding modal-sample-form">
                            <div className="col-xs-12 no-padding">
                                <hr style={{width:'100%'}} />
                                <div className="col-xs-12 col-sm-2">
                                    <LabelForm text="Fecha" />
                                    <InputForm
                                        id="date"
                                        value={this.state.date} 
                                        class="hour-input"
                                        handleChange={this.handleChange}
                                        disabled={true}
                                        type="date"
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-2">
                                    <LabelForm text="Hora" />
                                    <InputForm
                                        id="time"
                                        value={this.state.time} 
                                        class="hour-input"
                                        handleChange={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-4 no-padding">
                                    <LabelForm text="Tipo de muestra" />
                                    <SelectForm 
                                        id="sample_types_id"
                                        options={this.state.sampleTypes}
                                        value={this.state.sample_types_id}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <LabelForm text="No. Muestra" />
                                    <InputForm
                                        id="sample_number"
                                        value={this.state.sample_number} 
                                        handleChange={this.handleChange}
                                        disabled
                                        required
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-1" style={{textAlign:'right'}}>
                                    <IconButton 
                                        title="Generar número de muestra"
                                        styles={{marginTop:20}}
                                        action={this.getNextNumber}
                                        icon={download}
                                    />
                                </div>                                
                            </div>
                            <div className="col-xs-12 no-padding">
                                <div className="col-xs-12 col-sm-3">
                                    <LabelForm text="Tipo de Tubo" />
                                    <SelectForm 
                                        id="tube_type"
                                        options={this.state.tubeTypes}
                                        value={this.state.tube_type}
                                        handleChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-2">
                                    <LabelForm text="Brazo" />
                                    <SelectForm 
                                        id="arm"
                                        options={this.state.arms}
                                        value={this.state.arm}
                                        handleChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-3 no-padding">
                                    <LabelForm text="Vena" />
                                    <SelectForm 
                                        id="vein"
                                        options={this.state.veins}
                                        value={this.state.vein}
                                        handleChange={this.handleChange}
                                        class=" hour-input"
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-2">
                                    <LabelForm text="Volumen" />
                                    <InputForm
                                        id="volume"
                                        value={this.state.volume} 
                                        handleChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-2">
                                    <LabelForm text="Temperatura" />
                                    <InputForm
                                        id="temperature"
                                        value={this.state.temperature} 
                                        handleChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-12 no-padding">
                                <div className="col-xs-12 col-sm-6">
                                    <LabelForm text="Tomada por" />
                                    <AutocompleteForm 
                                        id="_medicals"
                                        inputProps={{name:'medical_staff_id', id:'medical_staff_id'}}
                                        options={this.state.medicals}
                                        reference="_handleMedicalStaff"
                                        handleChange={this.onAutocompleteChange}
                                        loading={this.state.load_medical}
                                        selected={this.state.index_medical !== -1 ? [this.state.medicals[this.state.index_medical]] : [] }
                                        onRef={ref => this.autocomplete_medical = ref}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <LabelForm text="Lugar de Colecta" />
                                    <SelectForm 
                                        id="convoke_place_id"
                                        options={this.state.convoke_places}
                                        value={this.state.convoke_place_id}
                                        handleChange={this.handleChange}
                                        loading={this.state.load_medical}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-12 no-padding">
                                <div className="col-xs-12">
                                    <input type="checkbox" name="maternal_flag" checked={this.state.maternal_flag} onChange={(e)=>this.onChecked(e)} />
                                    <span style={{marginLeft:'10px'}}>Muestra materna</span>
                                </div>
                                {this.state.maternal_flag &&
                                    <div className="col-xs-12">
                                        <LabelForm text="Nombre de Madre" />
                                        <InputForm
                                            id="mothers_name"
                                            value={this.state.mothers_name}
                                            handleChange={this.handleChange}
                                        />
                                    </div>	
                                }
                            </div>

                            <div className="col-xs-12 form-group">
                                <Toolbar
                                    {...this.props}
                                    disabled={this.state.sample_id === ''}
                                    labels={true}
                                    variables={{
                                        labels:'direct', 
                                        label_key:'label_sample_cells', 
                                        id:this.state.sample_id,
                                    }}
                                    onRef={ref => this.toolbar = ref}
                                />
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default RegisterSample;